import { getDeviceSchema, QUEUE } from "callable-data-objects";
import { CallableInput, CallableToggle } from "Components/Shared";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import APIAccountWebhookProvider from "Providers/APIWebhookProvider";
import React from "react";
import { Button, Divider, Form, Header, Segment } from "semantic-ui-react";

const CreateQueueForm = () => {
  const {
    save,
    nextExtension,
    validateExtension,
    validateName,
    validateQueueName,
  } = useDevice();

  const initValues = {
    type: QUEUE,
    name: "",
    extension: nextExtension,
    queue: {
      queueName: "",
      ttsLanguage: "en-GB-Standard-A",
      items: [
        {
          type: "say",
          text:
            "You have been placed in a queue. Please hold whilst we find a suitable agent",
        },
        {
          type: "pause",
          text: "10",
        },
        {
          type: "say",
          text: "All our agents are currently busy. Please hold",
        },
        {
          type: "pause",
          text: "10",
        },
      ],
      loop: 3,
      connectTo: "HANGUP",
    },
  };

  return (
    <APIAccountWebhookProvider>
      <Segment>
        <Header as='h3'>Create Queue</Header>
        <Divider />
        <Formik
          initialValues={initValues}
          validationSchema={getDeviceSchema(QUEUE)}
          onSubmit={(values, actions) => {
            save(values);
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Field
                name='name'
                label='Name'
                validate={validateName}
                component={CallableInput}
              />
              <Field
                name='extension'
                label='Extension'
                placeholder='100'
                type='number'
                validate={validateExtension}
                component={CallableInput}
              />
              <Field
                name='queue.queueName'
                label='Queue Name'
                validate={validateQueueName}
                component={CallableInput}
              />
              <Field
                name='queue.ringEndpoints'
                label='Ring Endpoints'
                component={CallableToggle}
              />

              <Button primary type='submit' disabled={!isEmpty(props.errors)}>
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </Segment>
    </APIAccountWebhookProvider>
  );
};

export default CreateQueueForm;
